// extracted by mini-css-extract-plugin
export default {"accepted":"styles_accepted__a8SYO","requesting":"styles_requesting__zdCVe"};